import { Fragment } from "react";

function FiInternalHeader({ onSeePlansClick, content }) {
  const { hero, value_cards: valueCards = [] } = content;

  return (
    <Fragment>
      <div className="fi-header-container">
        <div className="fi-header-hero">
          <div className="fi-header-hero-left">
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <h1 style={{ lineHeight: "120%" }}>{hero.heading}</h1>
              <p style={{ lineHeight: "150%" }}>{hero.description}</p>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                width: "100%",
              }}
            >
              <button
                className="cta-button primary rounded"
                onClick={onSeePlansClick}
              >
                {hero.secondary_cta}
              </button>
            </div>
          </div>
          <div className="fi-header-hero-right">
            <img
              src={`${process.env.PUBLIC_URL}/images/fi_hero.png`}
              alt={hero.image_alt}
            />
          </div>
        </div>
        <div className="fi-header-propositions">
          {valueCards.map((card) => (
            <div className="proposition-card" key={card.title}>
              <img
                src={`${process.env.PUBLIC_URL}${card.icon}`}
                alt={card.icon_alt}
              />
              <div>
                <p>
                  <strong>{card.title}</strong>
                </p>
                <span>{card.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
}

export default FiInternalHeader;
